import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.rumtek.co';
const DEFAULT_IMAGE = `${SITE_URL}/rumtek-logo.jpg`;

const defaults = {
  title: 'Investment Advisor India | NRI Investment Consultant | Mutual Fund Advisor Kolkata - RUMTEK FINVEST',
  description: 'RUMTEK FINVEST - Investment Advisor India & NRI Investment Consultant since 1996. Expert Mutual Fund Advisor Kolkata, Retirement Planning NRI, Wealth Management India. Book free consultation.',
  image: DEFAULT_IMAGE,
};

const SEO = ({ title, description, canonical, image, type = 'website', jsonLd, faqJsonLd }) => {
  const seoTitle = title || defaults.title;
  const seoDescription = description || defaults.description;
  const seoImage = image || defaults.image;
  const seoUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={seoUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Rumtek Finvest Pvt. Ltd." />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
      {faqJsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(faqJsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
